import { create } from 'zustand';
import type { Calendar, CalendarPage } from '@edwin-group/cj-graphql/generated/graphql';
import { toast } from '@/components/ui/use-toast';
import { getPage, getCalendar } from '@/services/calendar/calendar.service';

type AdminStore = {
  loading: boolean;
  page: CalendarPage | null;
  calendar: Calendar | null;
  onInit: () => Promise<void>;
  error: string | null;
};

export const useCalendarStore = create<AdminStore>()((set) => ({
  page: null,
  calendar: null,
  loading: true,
  error: null,
  onInit: async () => {
    set({ loading: true, error: null });
    try {
      const [pageResponse, calendarResponse] = await Promise.all([getPage(), getCalendar()]);
      set({ page: pageResponse.page, calendar: calendarResponse.data as Calendar });
    } catch (error) {
      toast({
        title: 'Error',
        description: `Failed to fetch calendar ${error}`,
        variant: 'destructive',
      });
      set({ error: error as string });
    } finally {
      set({ loading: false });
    }
  },
}));
